import { useEffect, useState } from 'react';
import { PortalDateInput } from 'components/PortalDatePicker';

const calendarDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
const displayDate = (date) => new Date(`${date}T12:00:00`).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });

export function presetPeriod(preset, now = new Date()) {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (preset === 'month') return { from: calendarDate(new Date(today.getFullYear(), today.getMonth(), 1)), to: calendarDate(today), preset };
    if (preset === 'last-month') return {
        from: calendarDate(new Date(today.getFullYear(), today.getMonth() - 1, 1)),
        to: calendarDate(new Date(today.getFullYear(), today.getMonth(), 0)), preset,
    };
    if (preset === '30-days') {
        const from = new Date(today);
        from.setDate(from.getDate() - 29);
        return { from: calendarDate(from), to: calendarDate(today), preset };
    }
    return { from: '', to: '', preset: 'all' };
}

export function periodLabel({ from, to }) {
    if (!from && !to) return 'All time';
    if (!from) return `Through ${displayDate(to)}`;
    if (!to) return `From ${displayDate(from)}`;
    return `${displayDate(from)} – ${displayDate(to)}`;
}

export default function RevenuePeriodFilter({ period, onApply }) {
    const [draft, setDraft] = useState(period);
    const [error, setError] = useState('');
    useEffect(() => { setDraft(period); setError(''); }, [period]);

    const selectPreset = (event) => {
        const preset = event.target.value;
        setError('');
        if (preset === 'custom') setDraft({ ...draft, preset });
        else onApply(presetPeriod(preset));
    };
    const submit = (event) => {
        event.preventDefault();
        if (draft.from && draft.to && draft.from > draft.to) {
            setError('From date must be on or before To date.');
            return;
        }
        setError('');
        onApply({ ...draft, preset: draft.from || draft.to ? 'custom' : 'all' });
    };
    const changeDate = (key, value) => {
        setError('');
        setDraft({ ...draft, [key]: value, preset: 'custom' });
    };
    return <form className="revenue-period" onSubmit={submit} aria-label="Revenue period filters" noValidate>
        <div className="revenue-period-fields">
            <label className="revenue-field">Period<select value={draft.preset} onChange={selectPreset}>
                <option value="all">All time</option><option value="month">This month</option>
                <option value="last-month">Last month</option><option value="30-days">Last 30 days</option><option value="custom">Custom dates</option>
            </select></label>
            <label className="revenue-field">From date<PortalDateInput label="From date" value={draft.from} aria-invalid={!!error}
                onChange={(event) => changeDate('from', event.target.value)} /></label>
            <label className="revenue-field">To date<PortalDateInput label="To date" value={draft.to} aria-invalid={!!error}
                onChange={(event) => changeDate('to', event.target.value)} /></label>
            <button type="submit" className="revenue-button revenue-button-primary">Apply dates</button>
        </div>
        {error && <p role="alert" className="revenue-date-error">{error}</p>}
    </form>;
}
